<template>
   <div class="m-0 formdynamic justify-content-md-between " style="padding-top:10px;">
        <div class="row pl-3 pr-3 pb-2 pt-2 mb-0" v-for="(item, index) in form_format" :key="index">
            <div v-for="(key, j) in item.fields" :key="j"  :class="key.css_class" class="p-0 " style="`margin-top:0px;  margin-right: 0px; margin-left: 0px;">
                <div class="formdynamic__item__field">
                    <label v-html="`${key.name} ${key.required ? `<b style='color:red;'>*</b>` : ''}`" class="modal-label" :for="key.name"/>
                    <select v-if="key.type === 'select' || key.type === 'select-multiple'"
                    :disabled="key.disabled"
                    :multiple="key.type === 'select-multiple' ? true : false"
                    :size="key.maxlength"
                    class="input-field custom-select"
                    :style="{'max-width': (key.max_width) ? key.max_width : ''}"
                    :required="key.required"
                    v-model="form_data[key.model_name]"
                    >
                        <option value='' :disabled="key.required" v-html="key.empty_option_name !== undefined && key.empty_option_name !== '' ? key.empty_option_name : 'Select an option'"/>
                        <option v-for="(value, i) in array_options[key.model_name]" :key="i" :value="value.id" v-html="key.label ? value[key.label] : value.name"/>
                    </select>

                    <span class="custom-control custom-checkbox" v-else-if="key.type === 'checkbox'">
                        <input 
                            :disabled="key.disabled"
                            :type="key.type" 
                            class="custom-control-input"
                            :id="`refAlt${index}`"
                            v-model="form_data[key.model_name]"
                        />
                        <label
                            class="custom-control-label ml-2"
                            :for="`refAlt${index}`"/>
                    </span>
                    <input v-else 
                        :placeholder="key['placeholder'] !== undefined ? key.placeholder : ''"
                        :disabled="key.disabled"
                        :step="key.step"
                        :type="key.type" 
                        :maxlength="key.maxlength"
                        style="max-width: 85%;"
                        :min="key.minlength !== undefined ? key.minlength : ''"
                        :max="key.maxlength"
                        :required="key.required"
                        v-model="form_data[key.model_name]"
                    />   
                </div>  
            </div>

            <slot :name="`col-${index}`"></slot>  
        </div>
   
   </div>
</template>

<script>
export default {
    name: 'FormDynamicV2',
    props:[
        'form_format',
        'form_data',
        'array_options'
    ]

}
</script>